module.exports = __webpack_public_path__ + "img/banner-gift.bdf9c2ea.png";